import {useFieldArray, useFormContext} from "react-hook-form";

import {InputField, InputFieldProps} from "@/components/form/fields/InputField/InputField.tsx";
import {ListInputItemsList} from "@/components/form/ListInputItemsList.tsx";
import {PhoneListInput} from "@/components/form/PhoneListInput.tsx";

export const PhoneListField = ({name, ...rest}: InputFieldProps) => {
  const {getValues, control} = useFormContext();
  const {remove} = useFieldArray({control, name});

  return (
    <>
      <InputField name={name} input={<PhoneListInput name={name} />} {...rest} />
      <ListInputItemsList items={getValues(name) || []} remove={remove} phoneNumber />
    </>
  );
};
